import { AlertColor } from '@mui/material';

import { useSnackbar } from '@/providers/SnackbarProvider/SnackbarProvider';

export const useToast = () => {
  const snackbar = useSnackbar();

  return (description: string, severity: AlertColor = 'success') => {
    snackbar({
      message: description,
      severity,
    });
  };
};
